"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DataTable = require("../../../components/DataTable");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var relationStatus = {
  0: 'Inactive',
  1: 'Active',
  2: 'Pending'
};
var columns = [{
  title: 'Employer Name',
  key: 'employerName',
  render: function render(_, record) {
    return record.employer.name;
  }
}, {
  title: 'Relation Status',
  key: 'relationStatus',
  render: function render(_, record) {
    return relationStatus[record.status];
  }
}, {
  title: 'Coupon Status',
  key: 'couponStatus',
  render: function render(_, record) {
    var couponStatus = function couponStatus() {
      if (!record.couponCode) {
        return 'No Coupon Applied';
      } else if (!!record.couponAppliedOn && !record.couponRemovedOn || (0, _momentTimezone.default)(record.couponAppliedOn) > (0, _momentTimezone.default)(record.couponRemovedOn)) {
        return 'Active';
      } else {
        return 'Inactive';
      }
    };
    return couponStatus();
  }
}, {
  title: 'Last Updated',
  key: 'updatedAt',
  render: function render(_, record) {
    return (0, _momentTimezone.default)(record.updatedAt).format('llll');
  }
}];
var PatientEmployerRelationsDetailsTable = function PatientEmployerRelationsDetailsTable(_ref) {
  var patientId = _ref.patientId,
    relations = _ref.relations,
    loading = _ref.loading;
  return /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    dataSource: relations,
    loading: loading,
    columns: columns
  });
};
var _default = PatientEmployerRelationsDetailsTable;
exports.default = _default;